export const getCurrentDate = () => {
  var days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
  var months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const current = new Date();
  const day = current.getDay();
  const date = `${days[day]}, ${current.getDate()}  ${
    months[current.getMonth()]
  }  ${current.getFullYear()}`;
  return date;
};

export const getCurrentMonthString = (value) => {
  var months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const current = new Date(value);
  return `${months[current.getMonth()]}  ${current.getFullYear()}`;
};

export const getCurrentMonth = () => {
  var months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const current = new Date();
  const date = `${current.getFullYear()}-${months[current.getMonth()]}`;
  return date;
};
